import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AddInfluencerGroup} from '../../../../models/influencer';
import {GroupService} from '../../../services/group-details/group.service';
import {UserService} from '../../../services/user.service';
import {
  ActionSource, EventTrackerService, Page, TargetType,
  UserActionType
} from '../../../services/event-tracker/event-tracker.service';
import {SendToReviewComponent} from '../../bottombar-influencer-fragement/send-to-review/send-to-review.component';

@Component({
  selector: 'add-influencer-to-group',
  templateUrl: './move-influencer-from-group.component.html',
  styleUrls: ['./move-influencer-from-group.component.scss']
})
export class MoveInfluencerFromGroupComponent implements OnInit, AfterViewInit {
  @ViewChild('AddInfluencerForReview')
  addInfluencerForReview: SendToReviewComponent;
  @Output()
  public backToPreviewInfluencerEvent = new EventEmitter<any>();
  @Output()
  public addInfluencerToGroupExecution = new EventEmitter<any>();
  @Output()
  public createNewGroupEvent = new EventEmitter<any>();
  @Input()
  public influencerGroupList: any[] = [];
  @Input()
  public pendingAddInfluencerGroup: AddInfluencerGroup;

  public influencerGroup: AddInfluencerGroup = new AddInfluencerGroup();

  constructor(private eventTracker: EventTrackerService) {}

  ngOnInit() {
    if (this.pendingAddInfluencerGroup) {
      this.influencerGroup = this.pendingAddInfluencerGroup;
    }
  }

  ngAfterViewInit() {
    if (this.pendingAddInfluencerGroup && this.addInfluencerForReview) {
      this.addInfluencerForReview.needToReview = this.pendingAddInfluencerGroup.addForReview;
      this.addInfluencerForReview.selectedReviewers = this.pendingAddInfluencerGroup.reviewList ? this.pendingAddInfluencerGroup.reviewList : [];
    }
  }

  addInfluencersToGroup() {
    this.addInfluencerToGroupExecution.emit(this.influencerGroup);
  }

  backToPreviewInfluencer() {
    this.backToPreviewInfluencerEvent.emit();
  }

  onSelectGroup(evt) {
    if (evt) {
      this.influencerGroup.description = evt.description;
      this.influencerGroup.influencerGroupName = evt.name;
    }
  }

  hasDescription() {
    return this.influencerGroup && this.influencerGroup.description && this.influencerGroup.description !== '';
  }

  createNewGroup() {
    this.createNewGroupEvent.emit(this.influencerGroup);
  }

  onChangeSelectedReviewers(evt) {
    this.influencerGroup.reviewList = evt.selectedReviewers;
    this.influencerGroup.addForReview = evt.addForReview;
    if (evt.needToSendMPEvent) {
      this.sendMPEventWhenChangingReviewer();
    }
  }

  private sendMPEventWhenChangingReviewer() {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
      id: this.influencerGroup.influencer_group_id,
      name: this.influencerGroup.influencerGroupName,
      type: TargetType.REQUEST_REVIEW
    }, {
      action: UserActionType.TOGGLE,
      source: ActionSource.ACTION_VIEW
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/move-influencer-from-group/move-influencer-from-group.component.ts